module.exports = __webpack_public_path__ + "img/J37-argentina.ca471805.png";